
import {
    EsriUrlProvider,
    GeoJSONLoader,
    JSONUrlProvider,
    CartoVistaJSONLoader
} from "cartovista";
import {show} from "cartovistaExtend/appTools/Alerts";
import {callService, deflate} from "cartovistaExtend/utils/ServerUtils";

    function _serviceErrorHandler(error, objs) {
        if (C.DEBUG) {
            console.log(objs);
            console.log(error);
            console.log(error.stack);
            show("ServerRequests_ServiceError", {"error": error});
        }
        return Promise.reject(error);
    };

    //do not use _serviceErrorHandler for LOGGER requests to prevent logging loop
    export function logClientError(errorLevel, clientError) {
        var postData = {"logAppName": C.APP_NAME, "errorLevel": errorLevel, "clientError": JSON.stringify(clientError), "f": "json"};
        var options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": false};
        return callService(C.URLS.LOGGER.LOG_CLIENT_ERROR, postData, options)
            .catch(function(error) {
                if (C.DEBUG) {
                    console.log(errorLevel, clientError);
                    console.error(error);
                    console.error(error.message);
                }
            });
    };

    export function login(username, password) {
        var postData = {"username": username, "password": password, "f": "json"};
        var options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.AUTH.LOGIN, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [username]);
            });
    };

    export function logout() {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "f": "json"};
        var options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.AUTH.LOGOUT, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error);
            });
    };

    export function ping() {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "f": "json"};
        var options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": false};
        return callService(C.URLS.AUTH.PING, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error);
            });
    };


    export function queryLayer(layerConfig, queryExpression, postData) {
        var postData = _.assign({
            "token": typeof C.APP_TOOLS.AUTH_SESSION != "undefined" ? C.APP_TOOLS.AUTH_SESSION.USER.TOKEN : "",
            "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null),
            "outFields": typeof layerConfig.QUERY_FIELDS != "undefined" ? layerConfig.QUERY_FIELDS.toString() : null,
            "joinKey": typeof layerConfig.JOIN_KEY != "undefined" ? layerConfig.JOIN_KEY : null,
            "getCompressedOutput": true,
            "getFromCache": true,
            "f": "json"
        }, postData);
        var options = {"method": "POST", "async": true, "compressedOutput": true, "showWaitCursor": true};
        return callService(C.URLS.QUERY_LAYERS[layerConfig.LAYER_ID], postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [layerConfig, queryExpression]);
            });
    };

    export function queryEsriLayer(projection, layerConfig, queryExpression, postData) {
        var postData = _.assign({
            outSr: "3857",
            outFields: typeof layerConfig.QUERY_FIELDS != "undefined" ? layerConfig.QUERY_FIELDS.join(",") : null,
            where: queryExpression,
            token: typeof C.APP_TOOLS.AUTH_SESSION != "undefined" ? C.APP_TOOLS.AUTH_SESSION.USER.TOKEN : "",
        }, postData);
        var datacolumns = _.map(layerConfig.FIELDS, "ID");
        var urlProvider = new EsriUrlProvider(C.URLS.QUERY_LAYERS[layerConfig.LAYER_ID], postData, datacolumns);
        return new GeoJSONLoader(urlProvider, projection, null, null, null,  datacolumns);
    };

    export function queryCartovistaLayer(projection, layerConfig) {
        var urlProvider = new JSONUrlProvider(C.URLS.QUERY_LAYERS[layerConfig.LAYER_ID]);
        return new CartoVistaJSONLoader(urlProvider,  projection);
    };

    //only geometry is required for baseLayer
    export function queryBaseLayer(layerConfig, queryExpression, queryFields, postData) {
        var postData = _.assign({
            "token": typeof C.APP_TOOLS.AUTH_SESSION != "undefined" ? C.APP_TOOLS.AUTH_SESSION.USER.TOKEN : "",
            "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null),
            "outFields": typeof queryFields != "undefined" ? queryFields.toString() : null,
            "joinKey": null,
            "getCompressedOutput": true,
            "getFromCache": true,
            "f": "json"
        }, postData);
        var options = {"method": "POST", "async": true, "compressedOutput": true, "showWaitCursor": false};
        return callService(C.URLS.QUERY_LAYERS[layerConfig.ZOOM_LAYERING.BASE_LAYER_ID], postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [layerConfig, queryExpression]);
            });
    };

    export function queryStore(storeConfig, queryExpression, postData) {
        var postData = _.assign({
            "token": typeof C.APP_TOOLS.AUTH_SESSION != "undefined" ? C.APP_TOOLS.AUTH_SESSION.USER.TOKEN : "",
            "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null),
            "outFields": storeConfig.QUERY_FIELDS.toString(),
            "joinKey": typeof storeConfig.JOIN_KEY != "undefined" ? storeConfig.JOIN_KEY : null,
            "getCompressedOutput": true,
            "getFromCache": true,
            "f": "json"
        }, postData);
        var options = {"method": "POST", "async": true, "compressedOutput": true, "showWaitCursor": true};
        return callService(C.URLS.QUERY_STORES[storeConfig.TABLE_ID], postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [storeConfig, queryExpression]);
            });
    };

    export function serviceAreas(facilitiesData, breakValues, breakUnits, polygonForMultipleFacilities, polygonOverlapType, travelMode, traversiersSaisonniers) {
        var postData = {
            "facilitiesData" : deflate(facilitiesData),
            "breakValues" : JSON.stringify(breakValues),
            "breakUnits" : breakUnits,
            "polygonForMultipleFacilities" : polygonForMultipleFacilities,
            "polygonOverlapType" : polygonOverlapType,
            "compressedInput" : true,
            "getCompressedOutput" : true,
            "travelMode" : travelMode,
            "eviterTraversiersSaisonniers" : traversiersSaisonniers,
            "f": "json"
        };
        var options = {"method": "POST", "async": true, "compressedOutput": true, "showWaitCursor": true};
        return callService(C.URLS.NETWORK_ANALYST.SERVICE_AREAS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [facilitiesData, breakValues, breakUnits, polygonForMultipleFacilities, polygonOverlapType, travelMode, traversiersSaisonniers]);
            });
    };

    export function findRoutes(facilitiesData, travelMode) {
        var postData = {
            "token": typeof C.APP_TOOLS.AUTH_SESSION != "undefined" ? C.APP_TOOLS.AUTH_SESSION.USER.TOKEN : "",
            "facilitiesData" : deflate(facilitiesData),
            "travelMode" : travelMode,
            "compressedInput" : true,
            "getCompressedOutput" : true,
            "f": "json"
        };
        var options = {"method": "POST", "async": true, "compressedOutput": true, "showWaitCursor": true};
        return callService(C.URLS.NETWORK_ANALYST.FIND_ROUTES, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [facilitiesData, travelMode]);
            });
    };

    export function contactUs(facilitiesData, userData) {
        var postData = {
            "facilitiesData" : deflate(facilitiesData),
            "userData" : deflate(userData),
            "compressedInput" : true,
            "f": "json"
        };
        var options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.CONTACT_US.SEND_ERROR, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [facilitiesData, userData]);
            });
    };

    export function updatePoints(queryExpression, featuresData) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "compressedInput": true, "featuresData": deflate(featuresData), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.UPDATE_POINTS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, featuresData);
            });
    };

    export function updateLines(queryExpression, featuresData) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "compressedInput": true, "featuresData": deflate(featuresData), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.UPDATE_LINES, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, featuresData);
            });
    };

    export function updateAnnotations(queryExpression, featuresData) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "compressedInput": true, "featuresData": deflate(featuresData), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.UPDATE_ANNOTATIONS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [queryExpression, featuresData]);
            });
    };

    export function updateSectors(queryExpression, featuresData) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "compressedInput": true, "featuresData": deflate(featuresData), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.UPDATE_SECTORS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [queryExpression, featuresData]);
            });
    };

    export function addLines(featuresData) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "compressedInput": true, "featuresData": deflate(featuresData), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.ADD_LINES, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, featuresData);
            });
    };

    export function addAnnotations(featuresData) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "compressedInput": true, "featuresData": deflate(featuresData), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.ADD_ANNOTATIONS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, featuresData);
            });
    };

    export function addSectors(featuresData) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "compressedInput": true, "featuresData": deflate(featuresData), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.ADD_SECTORS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, featuresData);
            });
    };

    export function deleteLines(queryExpression) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.DELETE_LINES, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, queryExpression);
            });
    };

    export function deleteAnnotations(queryExpression) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.DELETE_ANNOTATIONS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, queryExpression);
            });
    };

    export function deleteSectors(queryExpression) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.EDITION.DELETE_SECTORS, postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, queryExpression);
            });
    };

    export function downloadShapefile(layerConfig, queryExpression) {
        var postData = {"token": C.APP_TOOLS.AUTH_SESSION.USER.TOKEN, "queryExpression": JSON.stringify(typeof queryExpression != "undefined" ? queryExpression : null), "f": "json"},
            options = {"method": "POST", "async": true, "compressedOutput": false, "showWaitCursor": true};
        return callService(C.URLS.DOWNLOAD[layerConfig.LAYER_ID], postData, options)
            .catch(function(error) {
                return _serviceErrorHandler(error, [layerConfig, queryExpression]);
            });
    };
